<template>
  <div class="tabs_content_right">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'content-main'
}
</script>
